import React from "react";

const splitParagraphs = (text) =>
  String(text || "")
    .replace(/\r\n/g, "\n")
    .split(/\n{2,}/)
    .filter((para) => para.length > 0);

export default function BroadcastMessage({ text, className }) {
  const paragraphs = splitParagraphs(text);

  if (paragraphs.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {paragraphs.map((para, index) => (
        <p
          key={index}
          style={{
            whiteSpace: "pre-wrap",
            marginBottom: index === paragraphs.length - 1 ? 0 : 16,
            marginTop: 0,
          }}
        >
          {para}
        </p>
      ))}
    </div>
  );
}
